import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

export const ViewerSkeleton = () => (
  <ContentLoader
    width={181}
    height={37}
    title="Loading announcement viewer"
    uniqueKey="announcement-list-item-viewer"
    viewBox="0 0 181 37"
    {...DEFAULT_SETTINGS}>
    <rect x="0" y="3" rx="16" ry="16" width="32" height="32" />
    <rect x="37" y="0" width="110" height="16" rx="3" ry="3" />
    <rect x="37" y="21" width="144" height="16" rx="3" ry="3" />
  </ContentLoader>
);
